import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link, withRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Indicator from "./Indicator";
import { Person20Svg } from "../../svg";
import shopApi from "../../api/shop";
import { saveUserConnected, logoutUser } from "../../store/user/userActions";
import { fetchUserCart } from "../../store/cart";
import { toast } from 'react-toastify'; // Pour afficher des notifications
import { clearWislist, fetchUserWishlist } from "../../store/wishlist";


function IndicatorAccount({ history }) { // Ajoutez history en tant que prop
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);
    const locale = useSelector((state) => state.locale);

    const [loginEmail, setLoginEmail] = useState("");
    const [loginPassword, setLoginPassword] = useState("");

    const handleLoginSubmit = async (event) => {
        event.preventDefault();
        try {
            const response = await shopApi.login(loginEmail, loginPassword);
            if (response) {
                dispatch(saveUserConnected(response));
                dispatch(fetchUserCart(response.user.id, locale));
                dispatch(fetchUserWishlist(response.user.id));
                history.push('/'); // Remplacez '/home' par le chemin de votre page d'accueil
                setLoginEmail("");
                setLoginPassword("");
            }
        } catch (error) {
            toast.error("Erreur lors de la connection", {
                theme: "colored",
                autoClose: 20000,
            });
            console.error("Login failed", error);
        }
    };

    const handleLogout = () => {
        const refreshToken = user?.userConnected?.user?.refreshToken || user?.userConnected?.refreshToken;
        shopApi.logout(refreshToken);
        history.push('/');
        // dispatch(clearWishlist());
    };

    const getInitials = (name) => {
        return name
            ?.split(" ")
            .map((part) => part[0].toUpperCase())
            .join("");
    };

    const dropdown = user.isLoggedIn ? (
        <div className="account-menu">
            <Link to="/account/dashboard" className="account-menu__user">
                {/* <div className="account-menu__user-avatar">
                    <div className="avatar-initials">{getInitials(user?.userConnected?.firstName || user?.userConnected?.user?.firstName)}</div>
                </div> */}
                {/* <div className="account-menu__user-info">
                    <div className="account-menu__user-name">{user?.userConnected?.firstName || user?.userConnected?.user?.firstName}</div>
                    <div className="account-menu__user-email">{user?.userConnected?.email || user?.userConnected?.user?.email}</div>
                </div> */}
            </Link>
            <div className="account-menu__divider" />
            <ul className="account-menu__links">
                <li>
                    <Link to="/account/profile"><FormattedMessage id="Account.editProfile" defaultMessage="Edit Profile" /></Link>
                </li>
                <li>
                    <Link to="/account/orders"><FormattedMessage id="Account.orderHistory" defaultMessage="Order History" /></Link>
                </li>
                {/* <li>
                    <Link to="/account/addresses">Addresses</Link>
                </li> */}
                <li>
                    <Link to="/account/password"><FormattedMessage id="Account.password" defaultMessage="Password" /></Link>
                </li>
            </ul>
            <div className="account-menu__divider" />
            <div className="form-group account-menu__form-button">
                <button onClick={handleLogout} className="btn btn-primary btn-sm">
                    <FormattedMessage id="Account.logOut" defaultMessage="Log Out" />
                </button>
            </div>
        </div>
    ) : (
        <div className="account-menu">
            <form className="account-menu__form" onSubmit={handleLoginSubmit}>
                <div className="account-menu__form-title">
                    <FormattedMessage id="Account.logIn" defaultMessage="Log In" />
                </div>
                <div className="form-group">
                    <label htmlFor="header-signin-email" className="sr-only">
                        <FormattedMessage id="Account.email" defaultMessage="Email" />
                    </label>
                    <input
                        id="header-signin-email"
                        type="email"
                        className="form-control form-control-sm"
                        placeholder="Email address"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="header-signin-password" className="sr-only">
                        <FormattedMessage id="Account.password" defaultMessage="Password" />
                    </label>
                    <div className="account-menu__form-forgot">
                        <input
                            id="header-signin-password"
                            type="password"
                            className="form-control form-control-sm"
                            placeholder="Password"
                            value={loginPassword}
                            onChange={(e) => setLoginPassword(e.target.value)}
                        />
                        <Link to="/site/reset-password" className="account-menu__form-forgot-link">
                            <FormattedMessage id="Account.forgotPassword" defaultMessage="Forgot?" />
                        </Link>
                    </div>
                </div>
                <div className="form-group account-menu__form-button">
                    <button type="submit" className="btn btn-primary btn-sm">
                        <FormattedMessage id="Account.logInAction" defaultMessage="Login" />
                    </button>
                </div>
                <div className="account-menu__form-link">
                    <Link to="/account/login">
                        <FormattedMessage id="Account.createAccount" defaultMessage="Create An Account" />
                    </Link>
                </div>
            </form>
        </div>
    );

    return (
        <Indicator
            url="/account"
            dropdown={dropdown}
            icon={
                user.isLoggedIn ? (
                    <div className="account-menu__user-connected-avatar">
                        <div>{getInitials(user?.userConnected?.user?.firstName || user?.userConnected?.firstName)}</div>
                    </div>
                ) : (
                    <Person20Svg />
                )
            }
        />
    );
}

export default withRouter(IndicatorAccount); // Enveloppez le composant avec withRouter
